var CHARSET = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

window.setCookie = function(name, value, weeks) {
	var expires = "";
	if (weeks) {
		var date = new Date();
		date.setTime(date.getTime() + (weeks*7*24*60*60*1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "")  + expires + "; path=/; SameSite=Strict";
  }
  
window.getCookie = function(name, defaultValue) {
	var nameEq = name + "=";
	var value = defaultValue;
	var ca = document.cookie.split(";");
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == " ") c = c.substring(1, c.length);
		if (c.indexOf(nameEq) == 0) {
		  value = c.substring(nameEq.length, c.length);
		}
	}
	return value;
}

/**
 * Get page ID, or generate a new one
 */
window.vdx_getPageID = function() {
	if (!window.name) {		
		page_id = vdx_getUniqueID();
		window.name = page_id;
	} else {
		page_id = window.name;
	}
	return page_id;
}

window.vdx_getUniqueID = function(prefix) {
	var time = (new Date()).getTime(),				// base62 - 8 characters
		rnd = Math.floor(Math.random()*238327); 	// base62 - 3 characters

	return vdx_base62Encode(rnd) + vdx_base62Encode(time);
}

window.vdx_addReferrerToLinks = function(id) {
	document.addEventListener('mousedown', e => {
		var url, href, isAnchorLink, isValidLink, 
			t = e.target;
		
		if (t.tagName !== 'A') return;

		href = String(t.attributes.href.value);
				
		// Skip if empty link
		if (!href) return;

		isAnchorLink = href.charAt(0) === '#';
		isValidLink = href.includes('www.vindex') && !href.includes('tel:') && !href.includes('mailto:') && !href.includes('wp-admin');

		// console.log(href);
		
		if (!isAnchorLink && isValidLink) {
			url = new URL(href);
			url.searchParams.set('pr', id);		
			t.href = url.toString();
		}
	 });
}

// Cleanup tracking params on URL when no longer needed
window.vdx_cleanupURL = function() {
	var url = new URL(window.location),
		params = url.searchParams;
	
	params.delete('pr');
	params.delete('er');
	params.delete('et');

	if (!params.toString() == '') {
		url.search = '?' + params.toString();		
	} else {
		url.search = '';
	}
	
	window.history.replaceState({}, document.title, url.toString());

	return url.toString();
}

// NB: does not validate input
window.vdx_base62Encode = function(int) {

    if (int === 0) {
        return CHARSET[0];
    }

    var res = "";
    while (int > 0) {
        res = CHARSET[int % 62] + res;
        int = Math.floor(int / 62);
    }
    return res;
};

window.vdx_base62Decode = function(str) {
    var res = 0,
        length = str.length,
        i, char;
    for (i = 0; i < length; i++) {
        char = str.charCodeAt(i);
        if (char < 58) { // 0-9
            char = char - 48;
        } else if (char < 91) { // A-Z
            char = char - 29;
        } else { // a-z
            char = char - 87;
        }
        res += char * Math.pow(62, length - i - 1);
    }
    return res;
};

/**
 * Smoothly scroll page to element
 * @param {*} selector CSS selector
 * @param {*} duration Duration of scroll
 * @param {*} duration Target offset in pixels
 */
window.wplfScrollTo = function(selector, duration, offset = 0) {	

	var el = document.querySelector(selector);
	var ey = window.pageYOffset + el.getBoundingClientRect().top + offset;
	var startY = window.pageYOffset;
	var diff = ey - startY;
	var start;
  
	// Bootstrap our animation - it will get called right before next frame shall be rendered.
	window.requestAnimationFrame(function step(timestamp) {
	  if (!start) start = timestamp;
	  // Elapsed milliseconds since start of scrolling.
	  var time = timestamp - start;
	  // Get percent of completion in range [0, 1].
	  var percent = Math.min(time / duration, 1);
  
	  window.scrollTo(0, startY + diff * percent);
  
	  // Proceed with animation as long as we wanted it to.
	  if (time < duration) {
		window.requestAnimationFrame(step);
	  }
	});
}
